var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.284f7ba2bc094491118101ebf6529b5f.svg#g';
                    var viewUrl = 'sprites.284f7ba2bc094491118101ebf6529b5f.svg#view-g';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 116 116',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };